import {
  Button,
  Column,
  Grid,
  LinkButton,
  Row,
  Spacer,
  Icon,
  Text,
} from "@bunnix/components";
import { ForEach, Show, useState } from "@bunnix/core";
import AppHeaderMoreMenu from "./app-header-more-menu.mjs";
import InstallInstructionsPage from "./install-instructions-page.mjs";
import usePopover from "./hooks/usePopover.mjs";
import useDevice from "./hooks/useDevice.mjs";
import "./app-header-bar.css";

const HEADER_ITEMS = [
  { id: "headlines", name: "Notícias" },
  { id: "brazil", name: "Brasil" },
  { id: "politic", name: "Política" },
];

export default function AppHeaderBar(props = {}) {
  const { Popover, showPopover } = usePopover();
  const { selectedTopic = useState("headlines") } = props;
  const headerOptions = useState(HEADER_ITEMS);
  const hideInstallButton = useState(useDevice().isStandalone);

  const handleOptionsClick = (id) => {
    selectedTopic.set(id);
  };

  const handleInstallClick = () => {
    showPopover({
      contents: InstallInstructionsPage(),
      width: 420
    })
  };

  const RenderInstallButton = () =>
    Show(
      hideInstallButton.map((hidden) => !hidden),
      Button(
        {
          class: "app-header-save-button",
          click: handleInstallClick,
          "aria-label": "Adicionar à tela de início",
          title: "Adicionar à tela de início",
        },
        Icon({ name: "plus", size: 22 }),
      ),
    );

  const RenderOptions = () =>
    Row(
      { class: "app-header-options-expanded", gap: 24 },
      ForEach(headerOptions, { key: "id" }, (opt) =>
        Row(
          Show(
            selectedTopic.map((s) => s === opt.id),
            LinkButton(
              {
                class: "app-header-link",
                selected: true,
                click: () => handleOptionsClick(opt.id),
              },
              opt.name,
            ),
          ),
          Show(
            selectedTopic.map((s) => s !== opt.id),
            LinkButton(
              {
                class: "app-header-link",
                click: () => handleOptionsClick(opt.id),
              },
              opt.name,
            ),
          ),
        ),
      ),
    );

  return Column(
    {
      class: "app-header-bar",
      sticky: "top",
    },
    Popover(),
    Row(
      { class: "app-header-bar-contents", padding: "regular" },
      Text({ class: "app-header-text-logo" }, "Sem Viés"),

      Spacer(),
      Row(
        { gap: 24 },
        RenderOptions(),
        AppHeaderMoreMenu({ topicClick: handleOptionsClick })
      ),

      RenderInstallButton(),
    ),
  );
}
